<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="form-panel">
    <!--合同基本信息-->
    <div class="form-panel-head" style="display: flex;align-items: center;justify-content: space-between">
      合同基本信息
      <v-btn v-if="showBtnClose" flat color="error" @click="btnCloseClicked">x 关闭合同</v-btn>
    </div>
    <div class="form-panel-body">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">合同名称:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.name"
              v-model="item.name"
              :label="detailing?'':'请输入合同名称'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">公司名称:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-autocomplete
              v-if="!showBtnClose"
              ref="form.companyId"
              v-model="item.companyId"
              no-data-text="无可用数据"
              :items="companies"
              :label="detailing?'':'请选择公司'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-autocomplete>
            <v-text-field
              v-if="showBtnClose"
              :value="bindingCompanyName"
              outline
              solo
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">合同性质:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-select
              ref="form.type"
              v-model="item.type"
              :items="contractTypes"
              :label="detailing?'':'请选择合同性质'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-select>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>合同类型:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.category"
              v-model="item.category"
              :label="detailing?'':'请输入合同类型'"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>引进人:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.referrer"
              v-model="item.referrer"
              :label="detailing?'':'请输入引进人'"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">合同总金额:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.amount"
              v-model="item.amount"
              :label="detailing?'':'请输入合同总金额'"
              :rules="[rules.required,rules.isNumber]"
              :suffix="detailing?'':'元'"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">付款方式:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-select
              ref="form.payType"
              v-model="item.payType"
              :items="payTypes"
              :label="detailing?'':'付款方式'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-select>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>负责代理:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.proxy"
              v-model="item.proxy"
              :label="detailing?'':'请输入代理机构名称'"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">签约日期:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-menu
              v-model="showSignedDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="form.signedDate"
                  v-model="item.signedDate"
                  :label="detailing?'':'请输入签约日期'"
                  readonly
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.signedDate"
                locale="zh-cn"
                @input="showSignedDate = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>付款截止日期:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-menu
              v-model="showPayDue"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="form.payDue"
                  v-model="item.payDue"
                  :label="detailing?'':'付款截止日期'"
                  readonly
                  outline
                  solo
                  :disabled="detailing"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.payDue"
                locale="zh-cn"
                @input="showPayDue = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs3 md2 class="d-flex mt-2">
            <label>合同开始日期:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-menu
              v-model="showStartDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="form.startDate"
                  v-model="item.startDate"
                  :label="detailing?'':'请输入合同开始日期'"
                  readonly
                  outline
                  solo
                  :disabled="detailing"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.startDate"
                locale="zh-cn"
                @input="showStartDate = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>合同结束日期:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-menu
              v-model="showEndDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="form.endDate"
                  v-model="item.endDate"
                  :label="detailing?'':'请输入合同结束日期'"
                  readonly
                  outline
                  solo
                  :disabled="detailing"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.endDate"
                locale="zh-cn"
                @input="showEndDate = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2"></v-flex>
          <v-flex xs9 md4>
            <v-checkbox
              v-if="!detailing"
              v-model="item.dueNotification"
              primary
              hide-details
              label="开启缴费提醒"
              :disabled="currentUser.role==='firm'"
            ></v-checkbox>
            <template v-else>
              <v-text-field
                readonly
                outline
                solo
                disabled
                :value="item.dueNotification?'缴费提醒已开启':'缴费提醒已关闭'"
              ></v-text-field>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!--合同基本信息-->


    <!--合同相关信息-->
    <div class="form-panel-head">合同相关信息</div>
    <div class="form-panel-body">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">甲方经办人:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.operator1"
              v-model="item.operator1"
              :label="detailing?'':'请输入甲方经办人'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">乙方经办人:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.operator2"
              v-model="item.operator2"
              :label="detailing?'':'请输入乙方经办人'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">甲方签字人:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.signatureName1"
              v-model="item.signatureName1"
              :label="detailing?'':'请输入甲方签字人'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">乙方签字人:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.signatureName2"
              v-model="item.signatureName2"
              :label="detailing?'':'请输入乙方签字人'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">甲方盖章签字:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.signatureCompany1"
              v-model="item.signatureCompany1"
              :label="detailing?'':'请输入甲方盖章签字'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label :class="editing||adding?'required':''">乙方盖章签字:</label>
          </v-flex>
          <v-flex xs9 md4>
            <v-text-field
              ref="form.signatureCompany2"
              v-model="item.signatureCompany2"
              :label="detailing?'':'请输入乙方盖章签字'"
              :rules="[rules.required]"
              outline
              solo
              :disabled="detailing"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>备注:</label>
          </v-flex>
          <v-flex xs9 md10>
            <v-textarea
              v-if="!detailing"
              ref="form.notes"
              v-model="item.notes"
              outline
              solo
            ></v-textarea>
            <p v-if="detailing" class="detail-area">{{ item.notes }}</p>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
            <label>合同扫描件:</label>
          </v-flex>
          <v-flex v-if="item.documentInternalName" xs9 md10>
            <v-btn
              style="margin-right: 10px !important;"
              color="primary"
              :href="documentUrl"
              target="_blank"
            >
              查看现有合同
            </v-btn>
            <v-label>{{ item.documentFileName }}</v-label>
          </v-flex>
          <v-flex v-if="!item.documentInternalName&&!detailing" xs9 md10>
            <upload-btn
              title="上传文件"
              accept="application/pdf,image/jpeg"
              no-title-update
              style="padding: 0;"
              @file-update="fileUpdate"
            >
            </upload-btn>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
          </v-flex>
          <v-flex xs9 md10>
            <upload-btn
              v-if="item.documentInternalName && editing"
              title="如需更换现有合同，请选择文件"
              accept="application/pdf,image/jpeg"
              no-title-update
              style="padding: 0"
              @file-update="fileUpdate"
            >
            </upload-btn>
          </v-flex>
          <v-flex xs3 md2 class="d-flex mt-2">
          </v-flex>
          <v-flex xs9 md10>
            <v-chip v-if="file" close @input="clearFile">
              {{
                file.name
              }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!--合同相关信息-->

    <!--缴费提醒-->
    <div v-if="detailing" class="form-panel-head">缴费提醒</div>
    <div v-if="detailing" class="form-panel-body">
      <PaymentReminder ref="reminderTable" :dues="item.dues" :contract-id="item.contractId"/>
    </div>
    <!--缴费提醒-->
  </div>
</template>

<script>
  import UploadButton from "vuetify-upload-button";
  import {mapState,mapActions} from "vuex";
  import axios from "../axios";
  import PaymentReminder from './PaymentReminder';

  export default {
    name: "ContractForm",
    components: {
      "upload-btn": UploadButton,
      PaymentReminder
    },
    props: {
      adding: Boolean,
      editing: Boolean,
      detailing: Boolean,
      showBtnClose: Boolean,
      bindingCompanyName: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
        companiesMap: state => state.miniCompaniesMap,
        contractTypes: state => state.contractTypes,
        companyId:state=>state.companyId
      }),
      // adding(){
      //   return !this.$route.params.contractId;
      // },
      // editing() {
      //   return (!!this.$route.params.contractId) && this.$route.query.edit == 1
      // },
      // detailing(){
      //   return (!!this.$route.params.contractId) && this.$route.query.detail==1
      // },
      documentUrl() {
        return (
          process.env.VUE_APP_API + 'assets/' + this.item.documentInternalName
        );
      }
    },
    data: () => (
      {
        rules: {
          required: value => !!value || value === 0 || "必填",
          length5: value => (!!value && value.length >= 5) || "长度至少为5",
          length8: value => (!!value && value.length >= 8) || "长度至少为8",
          phoneNumber: value => {
            const pattern = /^1\d{10}$/;
            return pattern.test(value) || "请输入正确的手机号";
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
          },
          isNumber: value => {
            const pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;  ///^\d+$/
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的金额";
          },
        },
        item: {},
        payTypes: [
          {value: 0, text: "一次性"},
          {value: 3, text: "3个月"},
          {value: 6, text: "6个月"},
          {value: 12, text: "12个月"}
        ],
        showPayDue: false,
        showSignedDate: false,
        showStartDate: false,
        showEndDate: false,
        file: null,
        hasErrors: false,

      }
    ),
    methods: {
      ...mapActions(["setLoading"]),
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      save(callback) {
        //this.validate();
        //if (!this.hasErrors) {
        if (this.editing) {
          let formData = new FormData();
          formData.append("file", this.file);
          formData.append("data", JSON.stringify(this.item));
          this.setLoading(true);
          axios
            .put("/contracts/" + this.item.contractId, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then((res) => {
              this.setLoading(false);

              this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
                //this.$router.back();
                callback(res);
              });
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
              this.setLoading(false);
            });
        } else {
          let formData = new FormData();
          formData.append("file", this.file);
          formData.append("data", JSON.stringify(this.item));
          this.setLoading(true);
          axios
            .post("/contracts", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then((res) => {
              this.setLoading(false);

              this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
                //this.$router.back();
                callback(res);
              });
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
              this.setLoading(false);
            });
        }
        //}
      },
      fileUpdate(file) {
        this.file = file;
      },
      clearFile() {
        this.file = null;
      },
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      btnCloseClicked() {
        this.$emit("btnCloseClicked");
      },
    },
    created() {
      if (this.editing || this.detailing) {
        // axios.get("/contracts/" + this.$route.params.contractId).then(res => {
        //   this.item = res.data;
        // });

      } else {
        this.clearFile();

        this.item = {
          name: null,
          companyId: this.companyId,
          type: null,
          operator: null,
          amount: null,
          payType: null,
          payDue: null,
          signedDate: null,
          startDate: null,
          endDate: null,
          category: null,
          notes: null,
          proxy: null,
          signatureCompany1: null,
          signatureCompany2: null,
          signatureName1: null,
          signatureName2: null,
          contactName: '此字段已废弃',//原先的联系人（暂时不用）
        };

      }
    }
  };
</script>

<style scoped></style>

